import * as React from 'react';
import CalendarLtrRegular from 'mini-fluent-svg-icons/lib/icons/CalendarLtrRegular';
import styles from './CalendarIcon.scss';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

/**
 * Returns the calendar svg when the calendar module is not selected
 */
export const CalendarIconDefault = React.forwardRef(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type.
     *	> Unexpected any. Specify a different type. */
    (props: any, ref: React.RefObject<any>): JSX.Element => (
        <FluentSvgIcon ref={ref} icon={CalendarLtrRegular} iconStyles={styles.calendarModuleSVG} />
    )
);
